import { observer } from "mobx-react-lite";
import { useAppContext } from "../../../shared/functions/Context";
import { useState, useEffect, FormEvent } from "react";
import React from "react";

import MODAL_NAMES from "../ModalName";
import { hideModalFromId } from "../../../shared/functions/ModalShow";
import {
  defaultTrainingRequest,
  ITrainingRequest,
} from "../../../shared/models/TrainingRequestModel";
import { defaultUser, IUser } from "../../../shared/models/User";
import "./ViewTrainingRequests.scss"; // Import the newly created SCSS file
import { dateFormat_YY_MM_DD } from "../../shared/utils/utils";

const RequestTrainingRequestModal = observer(() => {
  const { store, api, ui } = useAppContext();
  const me = store.auth.me?.asJson;
  const departments = store.department.all;
  const [currentUser, setCurrentUser] = useState<IUser>({ ...defaultUser });
  const [courseRequest, setCourseRequest] = useState<ITrainingRequest>({
    ...defaultTrainingRequest,
  });
  const [loading, setLoading] = useState(false);
  console.log("Dept", departments);
  const [errors, setErrors] = useState<{
    attachments?: string;
    confirmation?: string;
  }>({});
  const getDepartmentName = (departmentId: string) => {
    const department = departments.find(
      (dept) => dept.asJson.id === departmentId
    );
    return department ? department.asJson.name : "Unknown Department";
  };
  const users = store.user.all.map((users) => users.asJson);

  const getName = (uid: string): string => {
    const currentUser = users.find((user) => user.uid === uid);
    console.log("current user", currentUser);

    return currentUser?.displayName || "Unknown Department";
  };
  const handleTrainingRequestSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("Training Request Submitted");
    const newErrors: { attachments?: string; confirmation?: string } = {};
    if (!courseRequest.confirmation) {
      newErrors.confirmation =
        "You must confirm that the information is true and accurate.";
    }
    if (me?.uid && me?.supervisor) {
      const newTrainingRequest: ITrainingRequest = {
        ...courseRequest,
        uid: me.uid,
        name: courseRequest.email
          ? courseRequest.email
          : currentUser?.email ?? "",
        dateRequested: Date.now(),
        supervisor: me.supervisor,
        requestType: "Employee",
        email: me?.email ?? "",
        department: me.department,
      };

      setLoading(true);
      try {
        if (store.trainingRequest.selected) {
          await api.trainingRequest.update(newTrainingRequest);
        } else {
          await api.trainingRequest.create(newTrainingRequest);
        }
      } catch (error) {
        console.error("Error updating or creating training request:", error);
      } finally {
        setLoading(false);
        onCancel();
      }
    }
  };

  const [uploadProgress, setUploadProgress] = useState<number[]>([]);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const uploadedFileLinks: string[] = [];
      const progress: number[] = Array(files.length).fill(0);
      setUploadProgress(progress);

      await Promise.all(
        Array.from(files).map(async (file, index) => {
          const uploadedFileLink =
            await api.uploadManager.uploadQualificationToStorage(
              file,
              `trainingQualification/${me?.uid}`,
              (snapshot) => {
                const percent = Math.round(
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                progress[index] = percent;
                setUploadProgress([...progress]);
              }
            );
          uploadedFileLinks.push(uploadedFileLink);
        })
      );

      setCourseRequest({
        ...courseRequest,
        attachment: [...courseRequest.attachment, ...uploadedFileLinks],
      });
    }
  };

  // Remove attachment from the array by index
  const handleRemoveAttachment = (index: number) => {
    const updatedAttachments = [...courseRequest.attachment];
    updatedAttachments.splice(index, 1); // Remove the attachment at the specified index
    setCourseRequest({
      ...courseRequest,
      attachment: updatedAttachments, // Update state with the remaining attachments
    });
  };

  useEffect(() => {
    // Load the selected personal development item into the state when the modal opens
    if (store.trainingRequest.selected) {
      setCourseRequest(store.trainingRequest.selected);
    }
  }, [store.trainingRequest.selected]);

  useEffect(() => {
    const loadAll = async () => {
      setLoading(true);
      try {
        await api.trainingBudget.getAll();
        await api.trainingRequest.getAll();
        await api.department.getAll();
      } catch (error) {
        ui.snackbar.load({
          id: Date.now(),
          message: "Failed to load.",
          type: "danger",
        });
      }
      setLoading(false);
    };
    loadAll();
  }, [api.trainingRequest, api.department, ui.snackbar]);

  const onCancel = () => {
    store.personalDevelopment.clearSelected();
    hideModalFromId(
      MODAL_NAMES.EXECUTION.PERSONAL_DEVELOPMENT_REQUEST_TRAINING_MODAL
    );
  };

  const purposeOptions = ["Development", "Certification", "Other"];

  return (
    <div className="view-training-modal uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      <button
        className="uk-modal-close-default"
        type="button"
        data-uk-close
      ></button>
      <div className="uk-container uk-container-large uk-margin-top">
        <h1 className="training-title">Training Request</h1>

        <form
          onSubmit={handleTrainingRequestSubmit}
        >
         

          <section className="uk-section uk-section-muted custom-section">
            <div className="uk-grid uk-grid-small uk-child-width-1-2@s">
              {/* Row for Name and Email */}
              <div className="uk-margin uk-width-1-1">
              <h2 className="section-title">Employee Information</h2>
                <div className="uk-grid uk-grid-small">
                  <div className="uk-width-1-2">
                    <label className="custom-label">Name:</label>
                    <input
                      className="custom-input"
                      type="text"
                      value={me?.displayName ?? "Not found."}
                      // onChange={(e) =>
                      //   setCourseRequest({
                      //     ...courseRequest,
                      //     name: e.target.value,
                      //   })
                      // }
                      disabled
                    />
                  </div>

                  <div className="uk-width-1-2">
                    <label className="custom-label">Email:</label>
                    <input
                      className="custom-input"
                      type="text"
                      value={me?.email ?? ""}
                      // onChange={(e) =>
                      //   setCourseRequest({
                      //     ...courseRequest,
                      //     email: e.target.value,
                      //   })
                      // }
                      disabled
                    />
                  </div>
                </div>
              </div>

              {/* Other fields */}
              <div className="uk-margin">
                <label className="custom-label">Department:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={getDepartmentName(me?.department ?? "Not found.")}
                />
              </div>
              <div className="uk-margin">
                <label className="custom-label">Phone Number:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.phoneNumber}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      phoneNumber: e.target.value,
                    })
                  }
                />
              </div>

              <div className="uk-margin">
                <label className="custom-label">Location:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.location}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      location: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="uk-margin">
                <label className="custom-label">Supervisor Name:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={getName(me?.supervisor ?? "Not Found")}
                  // onChange={(e) =>
                  //   setCourseRequest({
                  //     ...courseRequest,
                  //     supervisor: e.target.value,
                  //   })
                  // }
                  disabled
                />
              </div>

              <div className="uk-margin">
                <label className="custom-label">Supervisor Phone:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.supervisorPhone}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      supervisorPhone: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </section>

          {/* Course Information Section */}
          <section className="uk-section uk-section-muted custom-section">
            <h2 className="section-title">Course Information</h2>

            <div className="uk-grid uk-grid-small uk-child-width-1-2@m uk-grid-divider">
              {/* Course Name */}
              <div className="uk-margin">
              <hr/>
                <label className="custom-label">Course Name:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.courseName}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      courseName: e.target.value,
                    })
                  }
                  required
                />
              </div>

              {/* Preferred Date */}
              <div className="uk-margin">
                <label className="custom-label">Preferred Date:</label>
                <input
                  className="custom-input"
                  type="date"
                  value={
                    courseRequest.preferredDate
                      ? dateFormat_YY_MM_DD(courseRequest.preferredDate) // Use the formatted date if it exists
                      : new Date().toISOString().split("T")[0] // Set to today's date if empty
                  }
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      preferredDate: e.target.valueAsNumber,
                    })
                  }
                  required
                />
              </div>
              <div className="uk-margin">
                <label className="custom-label">Start Date:</label>
                <input
                  className="custom-input"
                  type="date"
                  value={
                    courseRequest.startDate
                      ? dateFormat_YY_MM_DD(courseRequest.startDate) // Use the formatted date if it exists
                      : new Date().toISOString().split("T")[0] // Set to today's date if empty
                  }
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      startDate: e.target.valueAsNumber,
                    })
                  }
                  required
                />
              </div>
              <div className="uk-margin">
                <label className="custom-label">End Date:</label>
                <input
                  className="custom-input"
                  type="date"
                  value={
                    courseRequest.endDate
                      ? dateFormat_YY_MM_DD(courseRequest.endDate) // Use the formatted date if it exists
                      : new Date().toISOString().split("T")[0] // Set to today's date if empty
                  }
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      endDate: e.target.valueAsNumber,
                    })
                  }
                  required
                />
              </div>

              {/* Offered By */}
              <div className="uk-margin">
                <label className="custom-label">Offered By:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.offeredBy}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      offeredBy: e.target.value,
                    })
                  }
                  required
                />
              </div>

              {/* Duration */}
              <div className="uk-margin">
                <label className="custom-label">Duration:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.duration}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      duration: e.target.value,
                    })
                  }
                  required
                />
              </div>

              {/* Location */}
              <div className="uk-margin">
                <label className="custom-label">Location:</label>
                <input
                  className="custom-input"
                  type="text"
                  value={courseRequest.courseLocation}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      courseLocation: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="uk-margin">
                <label className="custom-label">Budget:</label>
                <input
                  className="custom-input"
                  type="number"
                  value={courseRequest.budget}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      budget: e.target.valueAsNumber,
                    })
                  }
                  required
                />
              </div>
              {/* Brief Summary */}
              <div className="uk-margin uk-width-1-1">
                <label className="custom-label">
                  Brief Summary of Course Content:
                </label>
                <textarea
                  className="uk-textarea uk-margin-small-top"
                  value={courseRequest.courseSummary}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      courseSummary: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div>
          </section>

          <section className="uk-section uk-section-muted custom-section">
          <div className="uk-width-1-2">
          <h2 className="section-title">
              Purpose of Training
            </h2>
            <div className="uk-form-controls uk-margin">
              <select
                className="uk-select" // Added class for consistent styling
                value={courseRequest.purpose} // Set the selected value
                id="purpose"
                onChange={(e) =>
                  setCourseRequest({
                    ...courseRequest,
                    purpose: e.target.value, // Update purpose in courseRequest
                  })
                }
                required // Ensure the dropdown is required
              >
                <option value={""} disabled>
                  Select purpose...
                </option>
                {purposeOptions.map((purpose) => (
                  <option key={purpose} value={purpose}>
                    {purpose}
                  </option>
                ))}
              </select>
            </div>
          </div>
          </section>

          {/* File Upload and Validation */}
          <section className="uk-section uk-section-muted custom-section">
          <h2 className="section-title">Upload Document(s)</h2>
            <input
              type="file"
              multiple
              onChange={handleFileChange}
              className="custom-file-input uk-margin-small-top"
            />

            {uploadProgress.length > 0 &&
              uploadProgress.some((progress) => progress < 100) && (
                <div>
                  {uploadProgress.map((progress, index) => (
                    <div key={index} className="progress-bar uk-margin-small">
                      <div
                        className="progress-bar-fill"
                        style={{
                          width: `${progress}%`,
                          backgroundColor: "green",
                          height: "8px",
                          borderRadius: "4px",
                        }}
                      ></div>
                    </div>
                  ))}
                </div>
              )}

            <div>
              <h4>
                Please attach proof of completion documents before completing
              </h4>
              {courseRequest.attachment.length > 0 ? (
                <ul className="upload-list">
                  {courseRequest.attachment.map((url, index) => (
                    <li key={index}>
                      <span>Attachment {index + 1}</span>
                      <div>
                        <button
                          type="button"
                          className="btn-view"
                          onClick={() =>
                            window.open(url, "_blank", "noopener,noreferrer")
                          }
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="btn-remove"
                          onClick={() => handleRemoveAttachment(index)}
                        >
                          Remove
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No attachments found.</p>
              )}
            </div>
          </section>

          {/* Confirmation Box */}
          <section className="uk-section uk-section-default">
            <div className="uk-margin">
              <label>
                <input
                  className="uk-checkbox uk-margin-small-right"
                  type="checkbox"
                  checked={courseRequest.confirmation}
                  onChange={(e) =>
                    setCourseRequest({
                      ...courseRequest,
                      confirmation: e.target.checked,
                    })
                  }
                />
                I confirm that this information is true and accurate.
              </label>
              {errors.confirmation && (
                <p className="error-message">{errors.confirmation}</p>
              )}
            </div>
          </section>

          {/* Action Buttons */}
          <div className="uk-section uk-text-center button-container">
            <button className="uk-section custom-section"type="submit"  style={{ marginRight: '8px' }}>
              Submit Request
            </button>
            <button className="uk-section custom-section"
    style={{ backgroundColor: 'red', color: 'white', border: 'none' }}>
              Not Recommend
            </button>

          </div>
        </form>
      </div>
    </div>
  );
});

export default RequestTrainingRequestModal;
